import { useRouter } from 'next/navigation';
import { CopyToClipboard, RestAPI, useAppNav, useAsyncClick } from 'scripts';
import { message, Spin } from 'antd';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { API, PATH } from 'data';
import { PostBreadcrumbComp } from 'components';
import { __PostToolsPropsType } from './tools.type';
import { TbBookmark, TbBookmarkFilled, TbChevronRight, TbShare } from 'react-icons/tb';

export default function PostToolsComp({ post, setPost, categories }: __PostToolsPropsType) {
    const navigation = useRouter();
    const { profile } = useContext(GlobalContext);
    const appNav = useAppNav();
    const copyHandler = () => {
        if (navigator.share) {
            try {
                navigator.share({
                    title: 'تیک سبز',
                    text: post.title,
                    url: window.location.href,
                });
            } catch {
                console.log('share error');
            }
            CopyToClipboard(window.location.href);
            message.success('لینک پست مورد نظر شما با موفقیت در کلیپ بوردتان ذخیر شد');
        }
    };
    const onBookMark = useAsyncClick(() => {
        return new Promise((resolve) => {
            if (!profile) {
                appNav.push(PATH.login(window.location.href));
                return resolve(true);
            }
            if (!post.bookmark_id) {
                // bookmark the post
                RestAPI.post<{ id: number }>(API.bookmark.add, { post: post.id })
                    .then((res) => {
                        setPost({ ...post, bookmark_id: res.data.id });
                        resolve(true);
                    })
                    .catch(() => {
                        message.error('عملیات با خطا مواجه شد، لطفا بعدا دوباره امتحان کنید.');
                        resolve(true);
                    });
            } else {
                RestAPI.delete(API.bookmark.remove(post.bookmark_id))
                    .then(() => {
                        setPost({ ...post, bookmark_id: undefined });
                        resolve(true);
                    })
                    .catch(() => {
                        message.error('عملیات با خطا مواجه شد، لطفا بعدا دوباره امتحان کنید.');
                        resolve(true);
                    });
            }
        });
    });
    const onBookMarkHandler = () => {
        if (onBookMark.loading) return; // simulate disabled status for a div
        onBookMark.onClick(false);
    };

    return (
        <div className="center-content-y justify-content-between mb-5">
            {appNav.context}
            <div className="t-p2 t-40 t-l-gray1 center-content">
                <TbChevronRight className="pointer t-gray1 ml-1" size={20} onClick={() => navigation.back()} />
                <PostBreadcrumbComp category={post.category} categories={categories} />
            </div>
            <div className="center-content g-2">
                {onBookMark.loading ? (
                    <div className={`center-content`}>
                        <Spin size="small" className="d-flex-i center-content" />
                    </div>
                ) : post.bookmark_id ? (
                    <TbBookmarkFilled onClick={onBookMarkHandler} size={24} className="t-primary pointer" />
                ) : (
                    <TbBookmark onClick={onBookMarkHandler} size={24} className="pointer t-l-black1 t-d-gray2" />
                )}
                <TbShare className="pointer t-l-black1 t-d-gray2" size={24} onClick={copyHandler} />
            </div>
        </div>
    );
}
